import { render, staticRenderFns } from "./user_register.vue?vue&type=template&id=5656cb7c&scoped=true&"
import script from "./user_register.vue?vue&type=script&lang=js&"
export * from "./user_register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656cb7c",
  null
  
)

export default component.exports